import PropTypes from 'prop-types'
import { Box, Button, Stepper } from '@mui/material'

import { SHIPPING_STATUS_CODES } from '../../../common/constants'
import TrackingLineStep from './TrackingLineStep'
import useStyles from './styles'

import { addressPropTypes } from '../../../common/propTypes'
import useTranslations from '../../../i18n/useTranslations'

const TrackingLine = ({
  stepsData,
  canBeReturnedButton,
  activeStatusIndex,
  isShippingDetail,
  shippingInfo,
  shippingDates,
  showSeeReturn,
  addresses,
  isCancelled,
  shippingStatusCode,
}) => {
  const classes = useStyles()
  const t = useTranslations()
  const hasPudoStatus = stepsData.some(
    step => step.code === SHIPPING_STATUS_CODES.pudo,
  )

  const determineIsInternational = country => {
    const internationalCountries = ['ES', 'PT']
    return !internationalCountries.includes(country?.code || country)
  }

  return (
    <Box className={classes.row}>
      <Stepper
        alternativeLabel
        activeStep={activeStatusIndex}
        className={classes.trackingLine}
      >
        <>
          {stepsData.map((stepData, i) => (
            <TrackingLineStep
              key={stepData.code}
              {...stepData}
              type={
                //ÑAPA WEB1600
                shippingInfo?.lastShippingStatusCode?.lastStatusCode ===
                  'WEB1600' && stepData.code === 'WEB1500'
                  ? 'error'
                  : stepData?.type
              }
              showSeeReturn={
                showSeeReturn
                  ? shippingInfo?.relatedReturn?.returnShippingCode ??
                    shippingInfo?.relatedReturn?.reverseReturnShippingCode
                  : null
              }
              isCancelled={isCancelled}
              shippingStatusCode={shippingStatusCode}
              canBeReturnedButton={canBeReturnedButton}
              isShippingDetail={isShippingDetail}
              shippingInfo={shippingInfo}
              shippingDates={shippingDates}
              addresses={addresses}
              hasPudoStatus={hasPudoStatus}
              isResolved={stepData.isResolved}
              international={determineIsInternational(
                shippingInfo?.destinCountryCode,
              )}
            />
          ))}
        </>
      </Stepper>
      {canBeReturnedButton ? (
        <Box className={classes.buttonReturnedBox}>
          <Button
            size="small"
            onClick={canBeReturnedButton.onClick}
            className={classes.button}
          >
            {t(canBeReturnedButton.labelKey)}
          </Button>
        </Box>
      ) : null}
    </Box>
  )
}

TrackingLine.propTypes = {
  stepsData: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
      type: TrackingLineStep.propTypes.type,
      nextStepType: TrackingLineStep.propTypes.nextStepType,
      button: PropTypes.shape({
        labelKey: PropTypes.string,
        onClick: PropTypes.func,
      }),
    }),
  ),
  activeStatusIndex: PropTypes.number,
  canBeReturnedButton: PropTypes.shape({
    labelKey: PropTypes.string,
    onClick: PropTypes.func,
  }),
  isShippingDetail: PropTypes.bool,
  shippingInfo: PropTypes.object,
  shippingDates: PropTypes.shape({
    recordDate: PropTypes.string,
    deliveryDate: PropTypes.string,
  }),
  addresses: PropTypes.shape({
    from: addressPropTypes,
    to: addressPropTypes,
  }),
  isCancelled: PropTypes.bool,
  showSeeReturn: PropTypes.bool,
  shippingStatusCode: PropTypes.string,
}

export default TrackingLine
